// tea-quiz-hub-render-v13-boot-v11
(function () {
  if ((window.__teaQuizConstitutionLiveFixBuild || 0) < 16) {
    var ref =
      document.currentScript ||
      document.querySelector('script[src*="tea-quiz-constitution-hub-v13"]') ||
      document.querySelector('script[src*="/assets/"]');
    if (ref && ref.src && ref.src.indexOf('/assets/') !== -1) {
      var base = ref.src.split('/assets/')[0] + '/assets/';
      var boot = document.createElement('script');
      boot.src = base + 'quiz-constitution-live-fix-v12.js?hubboot=' + Date.now();
      boot.async = false;
      boot.setAttribute('data-tea-quiz-live-fix-v12', '');
      document.head.appendChild(boot);
    }
  }

  if (window.__teaQuizConstitutionHubV13Core) return;
  window.__teaQuizConstitutionHubV13Core = 1;

  function neutralizeLegacyQuizHubScripts() {
    window.__teaQuizHubRedirectLock = 0;
    try {
      sessionStorage.removeItem('teaQuizHubRedirectLock');
    } catch (error) {}

    window.__teaQuizIsOnHubResultsPage = function () {
      try {
        return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
      } catch (error) {
        return window.location.search.indexOf('view=quiz-results') !== -1;
      }
    };

    window.__teaQuizTryRedirectToResultsHub = function () {
      if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.showHubInPlace) {
        window.TeaQuizConstitutionHub.showHubInPlace();
        return true;
      }
      if (window.__teaQuizPaintHubNow) {
        window.__teaQuizPaintHubNow();
        return true;
      }
      return false;
    };
  }

  function injectHubResultsRescueCss() {
    if (document.getElementById('tea-quiz-hub-results-rescue-css')) return;
    var style = document.createElement('style');
    style.id = 'tea-quiz-hub-results-rescue-css';
    style.textContent =
      'html.quiz-results-from-quiz #quiz,' +
      'html.quiz-results-from-quiz #quiz-container,' +
      'html.quiz-results-from-quiz #shadow-quiz,' +
      'html.quiz-results-from-quiz .shopify-section:has(#quiz),' +
      'html.quiz-results-from-quiz .shopify-section:has(#shadow-quiz){display:none!important;}' +
      'html.quiz-results-from-quiz .quiz-constitution-results-section,' +
      'html.quiz-results-from-quiz #quiz-results,' +
      'html.quiz-results-from-quiz [data-quiz-constitution-results]{display:block!important;}';
    document.head.appendChild(style);
  }

  function shouldSkipHubTransition() {
    if (window.__teaQuizIsHubDismissedUntilRetake && window.__teaQuizIsHubDismissedUntilRetake()) return true;
    if (window.__teaQuizIsQuizTakeInProgress && window.__teaQuizIsQuizTakeInProgress()) return true;
    if (window.__teaQuizLooksLikeResult && window.__teaQuizLooksLikeResult()) return false;
    if (window.location.hash === '#quiz') return true;
    if (document.documentElement.classList.contains('tea-quiz-take-mode')) return true;
    try {
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
      if (sessionStorage.getItem('teaQuizDismissedUntilRetake') === '1') return true;
    } catch (error) {}
    return false;
  }

  function hideQuizResultSurface() {
    document.documentElement.classList.add('quiz-results-from-quiz');
    document
      .querySelectorAll(
        '#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, #quiz, #quiz-container, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
      )
      .forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
      });
  }

  function triggerHubTransition() {
    if (shouldSkipHubTransition()) return;
    hideQuizResultSurface();
    if (window.__teaQuizTriggerConstitutionHub) {
      window.__teaQuizTriggerConstitutionHub();
      return;
    }
    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.showHubInPlace) {
      window.TeaQuizConstitutionHub.showHubInPlace();
      return;
    }
    if (window.__teaQuizPaintHubNow) {
      window.__teaQuizPaintHubNow();
    }
  }

  if (!window.__teaQuizHubIsResultGuardV1) {
    window.__teaQuizHubIsResultGuardV1 = 1;

    neutralizeLegacyQuizHubScripts();
    injectHubResultsRescueCss();

    window.addEventListener(
      'message',
      function (event) {
        var data = event.data;
        if (!data || data.channel !== 'revenuehunt:quiz-renderer' || data.type !== 'isResult') return;
        if (shouldSkipHubTransition()) return;
        event.stopImmediatePropagation();
        triggerHubTransition();
      },
      true
    );

    try {
      if (new URLSearchParams(window.location.search).get('view') === 'quiz-results') {
        hideQuizResultSurface();
        window.setTimeout(triggerHubTransition, 0);
        window.setTimeout(triggerHubTransition, 300);
      }
    } catch (error) {}
  }

  if ((window.__teaQuizConstitutionHubVersion || 0) >= 13) return;
  window.__teaQuizConstitutionHubVersion = 13;

  neutralizeLegacyQuizHubScripts();
  injectHubResultsRescueCss();

  if (!window.__teaQuizTakeModeBootV1) {
    window.__teaQuizTakeModeBootV1 = 1;

    function bootIsQuizTakeMode() {
      if (window.location.hash === '#quiz') return true;
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      if (window.location.search.indexOf('_teaquiz_start=') >= 0) return true;
      try {
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      } catch (error) {}
      return false;
    }

    function bootIsResultsHubUrl() {
      if (window.location.search.indexOf('from=quiz') === -1) return false;
      try {
        return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
      } catch (error) {
        return window.location.search.indexOf('view=quiz-results') !== -1;
      }
    }

    function bootRestoreQuizVisibility() {
      document
        .querySelectorAll(
          '#quiz, #quiz-container, #shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
        )
        .forEach(function (node) {
          node.style.removeProperty('display');
        });
    }

    function bootEnableTakeMode() {
      if (document.documentElement.classList.contains('quiz-results-from-quiz')) return;
      if (window.__teaQuizLooksLikeResultStrict && window.__teaQuizLooksLikeResultStrict()) return;
      document.documentElement.classList.add('tea-quiz-take-mode');
      document.documentElement.classList.remove('quiz-results-from-quiz');
      bootRestoreQuizVisibility();
    }

    window.__teaQuizEnableTakeMode = window.__teaQuizEnableTakeMode || bootEnableTakeMode;

    function bootIsHubConstitutionHash() {
      var hash = window.location.hash || '';
      if (hash === '#quiz-results') return true;
      return hash.indexOf('#constitution-hub-') === 0;
    }

    function bootIsDedicatedQuizPagePath() {
      var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
      var root = getStoreRootUrl().replace(/\/$/, '') || '/';
      return path === '/pages/taishitsu-check' || path === '/quiz' || path === root + '/pages/taishitsu-check';
    }

    function bootShouldKeepHubResultsView(hasPersistedHubResults) {
      if (!hasPersistedHubResults()) return false;
      try {
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return false;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return false;
        if (window.location.search.indexOf('_teaquizretake=') >= 0) return false;
        if (window.location.search.indexOf('_teaquiz_start=') >= 0) return false;
      } catch (error) {}
      if (bootIsDedicatedQuizPagePath() && !bootIsResultsHubUrl() && !bootIsHubConstitutionHash()) {
        return false;
      }
      if (window.__teaQuizShouldKeepHubResultsView && window.__teaQuizShouldKeepHubResultsView()) {
        return true;
      }
      if (bootIsResultsHubUrl()) return true;
      if (bootIsHubConstitutionHash()) return true;
      if (document.documentElement.classList.contains('quiz-results-from-quiz')) return true;
      if (window.__teaQuizResolvedPageMode === 'hub') return true;
      return false;
    }

    function bootApplyHubResultsView() {
      document.documentElement.classList.add('quiz-results-from-quiz');
      document.documentElement.classList.remove('tea-quiz-take-mode');
      var hash = window.location.hash || '';
      if (hash.indexOf('#constitution-hub-') === 0 && window.__teaQuizScrollToConstitutionSection) {
        window.__teaQuizScrollToConstitutionSection(hash.slice(1), 'smooth');
      } else if (window.__teaQuizApplyHubResultsView) {
        window.__teaQuizApplyHubResultsView();
      } else if (window.__teaQuizRestoreHubAfterNavigation) {
        window.__teaQuizRestoreHubAfterNavigation();
      }
    }

    function bootApplyPageMode() {
      function hasPersistedHubResults() {
        try {
          return !!(
            sessionStorage.getItem('teaQuizConstitutionResults') ||
            localStorage.getItem('teaQuizConstitutionResults')
          );
        } catch (error) {
          return false;
        }
      }

      if (bootShouldKeepHubResultsView(hasPersistedHubResults)) {
        bootApplyHubResultsView();
        return;
      }

      if (bootIsResultsHubUrl()) {
        if (hasPersistedHubResults()) {
          document.documentElement.classList.add('quiz-results-from-quiz');
          document.documentElement.classList.remove('tea-quiz-take-mode');
          if (window.__teaQuizRestoreHubAfterNavigation) {
            window.__teaQuizRestoreHubAfterNavigation();
          }
        }
        return;
      }

      if (window.location.hash === '#quiz') {
        if (window.__teaQuizLooksLikeResultStrict && window.__teaQuizLooksLikeResultStrict()) {
          document.documentElement.classList.add('quiz-results-from-quiz');
          document.documentElement.classList.remove('tea-quiz-take-mode');
          if (window.__teaQuizRestoreHubAfterNavigation) {
            window.__teaQuizRestoreHubAfterNavigation();
          }
          return;
        }
        if (document.documentElement.classList.contains('quiz-results-from-quiz')) {
          return;
        }
        bootEnableTakeMode();
        return;
      }

      var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
      var root = getStoreRootUrl().replace(/\/$/, '') || '/';
      var returnPending = false;
      try {
        returnPending = sessionStorage.getItem('teaQuizHubReturnPending') === '1';
      } catch (error) {}
      if ((path === '/' || path === root) && hasPersistedHubResults() && returnPending) {
        try {
          if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return;
          if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return;
          if (window.location.search.indexOf('_teaquizretake=') >= 0) return;
        } catch (error) {}
        document.documentElement.classList.add('quiz-results-from-quiz');
        document.documentElement.classList.remove('tea-quiz-take-mode');
        if (window.__teaQuizRestoreHubAfterNavigation) {
          window.__teaQuizRestoreHubAfterNavigation();
        }
        return;
      }

      if (bootIsQuizTakeMode()) {
        bootEnableTakeMode();
        if (bootIsResultsHubUrl()) {
          var qs = window.location.search.indexOf('_teaquizretake=') >= 0 ? '?_teaquizretake=1' : '';
          try {
            history.replaceState(null, '', window.location.pathname + qs + '#quiz');
          } catch (error) {}
        }
        return;
      }
    }

    if (!document.getElementById('tea-quiz-take-mode-rescue-css')) {
      var bootStyle = document.createElement('style');
      bootStyle.id = 'tea-quiz-take-mode-rescue-css';
      bootStyle.textContent =
        'html.tea-quiz-take-mode .quiz-constitution-results-section,' +
        'html.tea-quiz-take-mode #quiz-results,' +
        'html.tea-quiz-take-mode [data-quiz-constitution-results]{display:none!important;}' +
        'html.tea-quiz-take-mode #MainContent>.shopify-section{display:block!important;}' +
        'html.tea-quiz-take-mode #quiz,' +
        'html.tea-quiz-take-mode #quiz-container,' +
        'html.tea-quiz-take-mode #shadow-quiz,' +
        'html.tea-quiz-take-mode .shopify-section:has(#quiz),' +
        'html.tea-quiz-take-mode .shopify-section:has(#shadow-quiz){display:block!important;}' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode #MainContent>.shopify-section{display:block!important;}' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode .shopify-section:has(#quiz),' +
        'html.quiz-results-from-quiz.tea-quiz-take-mode .shopify-section:has(#shadow-quiz){display:block!important;}';
      document.head.appendChild(bootStyle);
    }

    bootApplyPageMode();
    window.addEventListener('hashchange', bootApplyPageMode);
    document.addEventListener('DOMContentLoaded', bootApplyPageMode);
    window.addEventListener('load', bootApplyPageMode);
  }

  var SCORE_THRESHOLD = 9;
  var STORAGE_KEY = 'teaQuizConstitutionResults';
  var RAW_SCORES_KEY = 'teaQuizRawScores';
  var HUB_VIEW = 'quiz-results';
  var HUB_SECTION_ID = 'quiz-results';

  var CONSTITUTION_NAMES = [
    '気虚',
    '血虚',
    '気滞',
    '陰虚',
    '陽虚',
    '痰湿',
    '瘀血',
    '平和'
  ];

  function getStoreRootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') return root + '/';
    return root;
  }

  function clearConstitutionQuizStorage() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(RAW_SCORES_KEY);
      sessionStorage.removeItem('teaQuizAnswerLog');
      sessionStorage.removeItem('teaQuizHubActive');
      sessionStorage.removeItem('teaQuizHubReturnPending');
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(RAW_SCORES_KEY);
      localStorage.removeItem('teaQuizAnswerLog');
      localStorage.removeItem('teaQuizHubActive');
    } catch (error) {}
  }

  window.__teaQuizClearConstitutionResults = clearConstitutionQuizStorage;

  if (!window.__teaQuizConstitutionLiveFixV1) {
    window.__teaQuizShouldClearConstitutionResultsOnQuestion = function () {
      try {
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
        if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      } catch (error) {}
      return false;
    };
  }

  function isHomeWithPersistedHubResults() {
    if (window.__teaQuizShouldRestoreHubOnHomepage) {
      return window.__teaQuizShouldRestoreHubOnHomepage();
    }
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = getStoreRootUrl().replace(/\/$/, '') || '/';
    if (path !== '/' && path !== root) return false;
    if (!readPersistedResults()) return false;
    if (window.__teaQuizHubTransitionInProgress) return true;
    if (document.documentElement.classList.contains('quiz-results-from-quiz')) return true;
    try {
      if (new URLSearchParams(window.location.search).get('view') === HUB_VIEW) {
        return true;
      }
    } catch (error) {}
    try {
      if (sessionStorage.getItem('teaQuizHubReturnPending') === '1') {
        return true;
      }
      if (
        sessionStorage.getItem('teaQuizHubActive') === '1' ||
        localStorage.getItem('teaQuizHubActive') === '1'
      ) {
        return true;
      }
    } catch (error) {}
    return false;
  }

  function isQuizIntentActive() {
    if (window.__teaQuizPendingConstitutionHub) return false;
    if (document.documentElement.classList.contains('quiz-results-from-quiz')) return false;
    if (isHomeWithPersistedHubResults()) return false;

    try {
      if (new URLSearchParams(window.location.search).get('view') === HUB_VIEW) {
        return false;
      }
    } catch (error) {
      if (window.location.search.indexOf('view=' + HUB_VIEW) !== -1) {
        return false;
      }
    }

    if (window.__teaQuizLooksLikeResult && window.__teaQuizLooksLikeResult()) return false;

    try {
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
      if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
    } catch (error) {}

    if (window.__teaQuizHasActiveQuestion && window.__teaQuizHasActiveQuestion()) return true;

    return false;
  }

  function isQuizSectionActive() {
    return isQuizIntentActive();
  }

  function restoreQuizSectionVisibility() {
    document
      .querySelectorAll('#quiz, #quiz-container, #shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz')
      .forEach(function (node) {
        node.style.removeProperty('display');
      });
  }

  function suppressNativeQuizResultUi() {
    document
      .querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz')
      .forEach(function (host) {
        host.style.setProperty('display', 'none', 'important');
        if (!host.shadowRoot || host.shadowRoot.querySelector('#tea-quiz-hub-hide-style')) return;
        var style = document.createElement('style');
        style.id = 'tea-quiz-hub-hide-style';
        style.textContent =
          '.quiz.quiz-result,.quiz.quiz-result *,.quiz.results,.quiz.results *,' +
          '.quiz-result,.quiz-result *,.result-page,.result-page *,' +
          '.navigation-bar,.navigation-bar *,' +
          '.tea-quiz-recommendations-mount,.tea-quiz-recommendations-mount *,' +
          '.tea-recommendations,.tea-recommendations *{display:none!important;visibility:hidden!important;' +
          'height:0!important;overflow:hidden!important;pointer-events:none!important;}';
        host.shadowRoot.appendChild(style);
      });
  }

  function enableQuizTakeMode() {
    if (document.documentElement.classList.contains('quiz-results-from-quiz')) return;
    if (window.__teaQuizHubTransitionInProgress) return;
    if (window.__teaQuizLooksLikeResultStrict && window.__teaQuizLooksLikeResultStrict()) return;
    document.documentElement.classList.add('tea-quiz-take-mode');
    exitQuizResultsMode();
  }

  window.__teaQuizEnableTakeMode = enableQuizTakeMode;

  function exitQuizResultsMode() {
    if (window.__teaQuizHubTransitionInProgress) return;
    document.documentElement.classList.remove('quiz-results-from-quiz');
    if (document.body) {
      document.body.classList.remove('quiz-results-from-quiz');
    }
    restoreQuizSectionVisibility();
    if (window.__teaQuizClearHubRedirectLock) {
      window.__teaQuizClearHubRedirectLock();
    }
  }

  window.__teaQuizExitQuizResultsMode = exitQuizResultsMode;

  function readLiveQuizScores() {
    if (window.Quiz && window.Quiz.variableScores) {
      return window.Quiz.variableScores;
    }
    if (window.quiz && window.quiz.variableScores) {
      return window.quiz.variableScores;
    }
    if (window.quiz && window.quiz.variables && window.quiz.variables.scores) {
      return window.quiz.variables.scores;
    }
    return null;
  }

  function normalizeConstitutionScores(raw) {
    if (!raw || typeof raw !== 'object') return null;

    var source = raw;
    if (raw.scores && typeof raw.scores === 'object') {
      source = raw.scores;
    }

    var normalized = {};
    var hasValue = false;

    CONSTITUTION_NAMES.forEach(function (name) {
      var score = 0;
      if (source[name] != null) {
        score = Number(source[name]) || 0;
      } else {
        Object.keys(source).forEach(function (key) {
          if (String(key).replace(/\s/g, '') === name) {
            score = Number(source[key]) || 0;
          }
        });
      }
      if (score > 0) hasValue = true;
      normalized[name] = score;
    });

    return hasValue ? normalized : null;
  }

  function readPersistedRawScores() {
    try {
      var raw = sessionStorage.getItem(RAW_SCORES_KEY);
      if (!raw) {
        raw = localStorage.getItem(RAW_SCORES_KEY);
      }
      if (!raw) return null;
      return normalizeConstitutionScores(JSON.parse(raw));
    } catch (error) {
      return null;
    }
  }

  function readQuizVariableScores() {
    var live = normalizeConstitutionScores(readLiveQuizScores());
    if (live) return live;

    if (shouldRenderHubNow() || document.documentElement.classList.contains('quiz-results-from-quiz')) {
      return readPersistedRawScores();
    }

    return null;
  }

  function scoresSnapshot(scores) {
    return CONSTITUTION_NAMES.map(function (name) {
      return name + ':' + (scores[name] || 0);
    }).join('|');
  }

  function totalQualifiedScore(qualified) {
    var total = 0;
    qualified.forEach(function (item) {
      total += item.score;
    });
    return total;
  }

  function waitForStableScoresAndPersist(options, callback) {
    options = options || {};
    var maxAttempts = typeof options.maxAttempts === 'number' ? options.maxAttempts : 45;
    var intervalMs = typeof options.intervalMs === 'number' ? options.intervalMs : 200;
    var stableNeeded = typeof options.stableNeeded === 'number' ? options.stableNeeded : 3;
    var attempts = 0;
    var lastSnapshot = null;
    var stableCount = 0;
    var stableScores = null;
    var stableQualified = null;
    var latestScores = null;

    function rememberStable(scores, qualified) {
      if (!scores || !qualified || !qualified.length) return;
      stableScores = scores;
      stableQualified = qualified;
    }

    function finish() {
      var scores = stableScores || latestScores;
      if (!scores) {
        callback(null, null);
        return;
      }
      var qualified = stableQualified || buildQualifiedConstitutions(scores, options.threshold);
      if (!qualified.length) {
        callback(null, null);
        return;
      }
      persistResults(qualified, scores, { force: options.force });
      callback(qualified, scores);
    }

    function tick() {
      attempts += 1;
      var scores = normalizeConstitutionScores(readLiveQuizScores());
      if (scores) {
        latestScores = scores;
        var qualified = buildQualifiedConstitutions(scores, options.threshold);
        var snapshot = scoresSnapshot(scores);

        if (snapshot === lastSnapshot) {
          stableCount += 1;
          rememberStable(scores, qualified);
        } else {
          stableCount = 1;
          lastSnapshot = snapshot;
          rememberStable(scores, qualified);
        }

        if (stableCount >= stableNeeded && stableQualified) {
          finish();
          return;
        }
      }
      if (attempts >= maxAttempts) {
        finish();
        return;
      }
      window.setTimeout(tick, intervalMs);
    }

    tick();
  }

  function assignPercents(list) {
    if (!list.length) return list;
    if (list.length === 1) {
      list[0].percent = 100;
      return list;
    }

    var total = 0;
    list.forEach(function (item) {
      total += item.score;
    });

    var assigned = 0;
    list.forEach(function (item, index) {
      if (index === list.length - 1) {
        item.percent = Math.max(0, 100 - assigned);
        return;
      }
      item.percent = total > 0 ? Math.round((item.score / total) * 100) : 0;
      assigned += item.percent;
    });

    return list;
  }

  function buildQualifiedConstitutions(scores, threshold) {
    var minScore = typeof threshold === 'number' ? threshold : SCORE_THRESHOLD;
    var list = [];

    CONSTITUTION_NAMES.forEach(function (name) {
      var score = Number(scores && scores[name] != null ? scores[name] : 0);
      if (score >= minScore) {
        list.push({ name: name, score: score, percent: 0 });
      }
    });

    list.sort(function (a, b) {
      return b.score - a.score;
    });

    return assignPercents(list);
  }

  function shouldReplacePersistedResults(qualified, scores) {
    var existing = readPersistedResults();
    if (!existing || !existing.qualified || !existing.qualified.length) return true;
    if (scores && existing.allScores && typeof existing.allScores === 'object') {
      var scoreChanged = CONSTITUTION_NAMES.some(function (name) {
        return Number(scores[name] || 0) !== Number(existing.allScores[name] || 0);
      });
      if (scoreChanged) return true;
    }
    var existingNames = existing.qualified
      .map(function (item) {
        return item.name;
      })
      .sort()
      .join('|');
    var nextNames = qualified
      .map(function (item) {
        return item.name;
      })
      .sort()
      .join('|');
    if (existingNames !== nextNames) return true;
    if (qualified.length > existing.qualified.length) return true;
    if (qualified.length < existing.qualified.length) return false;
    return totalQualifiedScore(qualified) >= totalQualifiedScore(existing.qualified);
  }

  function persistResults(qualified, scores, options) {
    options = options || {};
    if (!options.force && !shouldReplacePersistedResults(qualified, scores)) return;
    try {
      var savedAt = Date.now();
      var answerLog = null;
      if (window.__teaQuizCaptureAnswerLog) {
        answerLog = window.__teaQuizCaptureAnswerLog();
      }
      var existing = readPersistedResults();
      if (!answerLog && existing && Array.isArray(existing.answerLog)) {
        answerLog = existing.answerLog;
      }
      if (!answerLog && window.__teaQuizReadPersistedAnswerLog) {
        answerLog = window.__teaQuizReadPersistedAnswerLog();
      }
      var payload = JSON.stringify({
        qualified: qualified,
        allScores: scores || null,
        answerLog: answerLog || null,
        savedAt: savedAt
      });
      sessionStorage.setItem(STORAGE_KEY, payload);
      sessionStorage.setItem('teaQuizHubActive', '1');
      try {
        localStorage.setItem(STORAGE_KEY, payload);
        localStorage.setItem('teaQuizHubActive', '1');
      } catch (error) {}
      if (answerLog) {
        var answerPayload = JSON.stringify(answerLog);
        sessionStorage.setItem('teaQuizAnswerLog', answerPayload);
        try {
          localStorage.setItem('teaQuizAnswerLog', answerPayload);
        } catch (error) {}
      }
      if (scores) {
        var rawPayload = JSON.stringify({
          scores: scores,
          savedAt: savedAt
        });
        sessionStorage.setItem(RAW_SCORES_KEY, rawPayload);
        try {
          localStorage.setItem(RAW_SCORES_KEY, rawPayload);
        } catch (error) {}
      }
    } catch (error) {}
  }

  function getHubDisplayData() {
    var live = normalizeConstitutionScores(readLiveQuizScores());
    if (live) {
      var liveQualified = buildQualifiedConstitutions(live);
      if (liveQualified.length) {
        persistResults(liveQualified, live);
        return { qualified: liveQualified, savedAt: Date.now() };
      }
    }

    var scores = readPersistedRawScores();
    if (scores) {
      var qualified = buildQualifiedConstitutions(scores);
      if (qualified.length) {
        persistResults(qualified, scores);
        return { qualified: qualified, savedAt: Date.now() };
      }
    }

    return readPersistedResults();
  }

  function readPersistedResults() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        raw = localStorage.getItem(STORAGE_KEY);
      }
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.qualified) || !parsed.qualified.length) return null;

      var needsPercents = parsed.qualified.some(function (item) {
        return typeof item.percent !== 'number';
      });
      if (needsPercents) {
        parsed.qualified = assignPercents(parsed.qualified.slice());
        persistResults(parsed.qualified);
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function buildHubUrl() {
    return getStoreRootUrl() + '?from=quiz&view=' + HUB_VIEW + '#quiz-results';
  }

  function buildDetailUrl(name) {
    return (
      getStoreRootUrl() +
      'collections/' +
      encodeURIComponent(name) +
      '?from=quiz&view=detail#constitution-info'
    );
  }

  function captureAndPersistFromQuiz(threshold) {
    var scores = normalizeConstitutionScores(readLiveQuizScores());
    if (!scores) return null;
    var qualified = buildQualifiedConstitutions(scores, threshold);
    if (!qualified.length) return null;
    persistResults(qualified, scores);
    return qualified;
  }

  function captureAndPersistFromQuizStable(threshold, callback) {
    waitForStableScoresAndPersist({ threshold: threshold, force: true }, function (qualified) {
      callback(qualified);
    });
  }

  function redirectToResultsHub(options) {
    options = options || {};
    if (window.__teaQuizIsOnHubResultsPage && window.__teaQuizIsOnHubResultsPage()) {
      return true;
    }
    if (window.__teaQuizHubRedirectLock) {
      return true;
    }
    var qualified = captureAndPersistFromQuiz(options.threshold);

    if (!qualified && options.fallbackSuffix) {
      qualified = [{ name: options.fallbackSuffix, score: SCORE_THRESHOLD, percent: 100 }];
      persistResults(qualified);
    }

    if (!qualified || !qualified.length) return false;

    window.location.replace(buildHubUrl());
    return true;
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderHub(root) {
    if (!root) return false;
    if (window.__teaQuizRenderConstitutionHub) {
      return window.__teaQuizRenderConstitutionHub(root);
    }

    var data = getHubDisplayData();
    if (!data) {
      root.innerHTML =
        '<div class="quiz-constitution-results__empty page-width">' +
          '<p class="quiz-constitution-results__empty-text">体質チェックの結果が見つかりませんでした。</p>' +
          '<p><a class="quiz-constitution-results__retry button button--primary" href="' +
            escapeHtml(getStoreRootUrl() + '#quiz') +
          '">体質チェックをはじめる</a></p>' +
        '</div>';
      return true;
    }

    return false;
  }

  function shouldRenderHubNow() {
    if (window.__teaQuizHubTransitionInProgress) return true;
    if (document.documentElement.classList.contains('quiz-results-from-quiz')) return true;
    if (isHomeWithPersistedHubResults()) return true;
    if (isQuizIntentActive()) return false;
    return isHubResultsUrlNow();
  }

  function isHubResultsUrlNow() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = getStoreRootUrl().replace(/\/$/, '') || '/';
    if (path === '/pages/quiz-results' || path === root + '/pages/quiz-results') return true;
    try {
      return new URLSearchParams(window.location.search).get('view') === HUB_VIEW;
    } catch (error) {
      return window.location.search.indexOf('view=' + HUB_VIEW) !== -1;
    }
  }

  function findHubRoot() {
    return (
      document.querySelector('.quiz-constitution-results-section [data-quiz-constitution-results]') ||
      document.querySelector('#quiz-results [data-quiz-constitution-results]') ||
      document.querySelector('[data-quiz-constitution-results]')
    );
  }

  function needsPaint(root) {
    if (!root) return true;
    if (root.querySelector('.quiz-constitution-results__toc-wrap')) return false;
    var data = readPersistedResults();
    if (root.querySelector('.quiz-constitution-results__loading-text')) return true;
    if (root.querySelector('.quiz-constitution-results__empty') && data) return true;
    if (!data) {
      return !root.querySelector('.quiz-constitution-results__empty');
    }
    return true;
  }

  function showHubInPlace(options) {
    options = options || {};
    if (!options.force && window.__teaQuizHasActiveQuestion && window.__teaQuizHasActiveQuestion()) return;
    document.documentElement.classList.remove('tea-quiz-take-mode');
    if (window.__teaQuizResetQuizSession) window.__teaQuizResetQuizSession();
    if (window.__teaQuizHideNativeQuizResult) {
      window.__teaQuizHideNativeQuizResult();
    }
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var rootPath = getStoreRootUrl().replace(/\/$/, '') || '/';
    if (path === '/' || path === rootPath) {
      if (window.__teaQuizEnsureHubHistoryEntry) {
        window.__teaQuizEnsureHubHistoryEntry('push');
      } else {
        try {
          if (!window.__teaQuizHubHistoryPushed) {
            history.pushState({ teaQuizHub: 1 }, '', buildHubUrl());
            window.__teaQuizHubHistoryPushed = 1;
          } else {
            history.replaceState({ teaQuizHub: 1 }, '', buildHubUrl());
          }
        } catch (error) {}
      }
    }
    document.documentElement.classList.add('quiz-results-from-quiz');
    suppressNativeQuizResultUi();
    if (window.__teaQuizClearRedirectOverlay) {
      window.__teaQuizClearRedirectOverlay();
    }
    window.__teaQuizPendingConstitutionHub = 0;
    captureAndPersistFromQuizStable(undefined, function () {
      mountHubPage();
    });
    mountHubPage();
  }

  if (!window.__teaQuizTriggerConstitutionHub) {
    window.__teaQuizTriggerConstitutionHub = showHubInPlace;
  }
  if (!window.__teaQuizPaintHubNow || (window.__teaQuizConstitutionLiveFixBuild || 0) < 12) {
    window.__teaQuizPaintHubNow = showHubInPlace;
  }

  function mountHubPage() {
    var forceHub =
      window.__teaQuizHubTransitionInProgress ||
      document.documentElement.classList.contains('quiz-results-from-quiz') ||
      isHomeWithPersistedHubResults();

    if (forceHub) {
      document.documentElement.classList.add('quiz-results-from-quiz');
      document.documentElement.classList.remove('tea-quiz-take-mode');
    } else if (isQuizIntentActive()) {
      exitQuizResultsMode();
      return;
    }

    if (!forceHub && !shouldRenderHubNow()) {
      return;
    }

    document.documentElement.classList.add('quiz-results-from-quiz');
    document.documentElement.classList.remove('tea-quiz-take-mode');
    if (window.__teaQuizClearRedirectOverlay) {
      window.__teaQuizClearRedirectOverlay();
    }

    var root = findHubRoot();
    if (!root) return;
    if (!needsPaint(root)) return;

    if (window.__teaQuizRenderConstitutionHub) {
      window.__teaQuizRenderConstitutionHub(root);
    } else {
      renderHub(root);
    }
    root.dataset.rendered = 'true';
  }

  function retryMountHubPage() {
    var root = findHubRoot();
    if (root && root.querySelector('.quiz-constitution-results__toc-wrap')) {
      stopHubClassObserver();
      return;
    }
    if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) {
      stopHubClassObserver();
      return;
    }
    if (isHomeWithPersistedHubResults()) {
      if (window.__teaQuizRestoreHubAfterNavigation) {
        window.__teaQuizRestoreHubAfterNavigation();
        return;
      }
    }
    if (isQuizIntentActive() && !window.__teaQuizHubTransitionInProgress) {
      exitQuizResultsMode();
      return;
    }
    if (!shouldRenderHubNow() && !document.documentElement.classList.contains('quiz-results-from-quiz')) {
      return;
    }
    captureAndPersistFromQuizStable(undefined, function () {
      mountHubPage();
    });
  }

  window.TeaQuizConstitutionHub = {
    SCORE_THRESHOLD: SCORE_THRESHOLD,
    HUB_VIEW: HUB_VIEW,
    HUB_SECTION_ID: HUB_SECTION_ID,
    CONSTITUTION_NAMES: CONSTITUTION_NAMES,
    buildQualifiedConstitutions: buildQualifiedConstitutions,
    readQuizVariableScores: readQuizVariableScores,
    clearConstitutionQuizStorage: clearConstitutionQuizStorage,
    exitQuizResultsMode: exitQuizResultsMode,
    enableQuizTakeMode: enableQuizTakeMode,
    isQuizSectionActive: isQuizSectionActive,
    captureAndPersistFromQuiz: captureAndPersistFromQuiz,
    captureAndPersistFromQuizStable: captureAndPersistFromQuizStable,
    waitForStableScoresAndPersist: waitForStableScoresAndPersist,
    readPersistedResults: readPersistedResults,
    persistResults: persistResults,
    buildHubUrl: buildHubUrl,
    buildDetailUrl: buildDetailUrl,
    redirectToResultsHub: redirectToResultsHub,
    renderHub: renderHub,
    mountHubPage: mountHubPage,
    showHubInPlace: showHubInPlace
  };

  window.__teaQuizPaintHubNow = showHubInPlace;
  window.__teaQuizTryRedirectToResultsHub = function () {
    if (window.__teaQuizTriggerConstitutionHub) {
      window.__teaQuizTriggerConstitutionHub({ force: true });
      return true;
    }
    showHubInPlace({ force: true });
    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHubPage);
  } else {
    mountHubPage();
  }

  scheduleHubRetry(0, retryMountHubPage);
  scheduleHubRetry(300, retryMountHubPage);
  scheduleHubRetry(1200, retryMountHubPage);
  scheduleHubRetry(2500, retryMountHubPage);
  scheduleHubRetry(5000, retryMountHubPage);

  window.addEventListener(
    'message',
    function (event) {
      var data = event.data;
      if (!data || data.channel !== 'revenuehunt:quiz-renderer') return;

      if (data.type === 'isQuestion') {
        if (window.__teaQuizShouldIgnoreQuestionForHubRestore && window.__teaQuizShouldIgnoreQuestionForHubRestore()) {
          event.stopImmediatePropagation();
          if (window.__teaQuizRestoreHubAfterNavigation) {
            window.__teaQuizRestoreHubAfterNavigation();
          }
          return;
        }
        if (
          !window.__teaQuizShouldClearConstitutionResultsOnQuestion ||
          window.__teaQuizShouldClearConstitutionResultsOnQuestion()
        ) {
          clearConstitutionQuizStorage();
        }
        return;
      }

      if (data.type !== 'isResult') return;
      if (window.__teaQuizShouldSkipHubTransitionForResultEvent && window.__teaQuizShouldSkipHubTransitionForResultEvent()) {
        return;
      }
      if (window.__teaQuizPrepareForHubTransition) {
        window.__teaQuizPrepareForHubTransition();
      } else {
        document.documentElement.classList.remove('tea-quiz-take-mode');
        if (window.__teaQuizResetQuizSession) window.__teaQuizResetQuizSession();
      }
      event.stopImmediatePropagation();
      showHubInPlace({ force: true });
      waitForStableScoresAndPersist({ force: true }, function (qualified) {
        if (!qualified || !qualified.length) return;
        mountHubPage();
      });
    },
    true
  );

  var retryMountTimer = null;
  var classObserver = null;
  var hubRetryTimeouts = [];

  function stopHubClassObserver() {
    if (retryMountTimer) {
      window.clearTimeout(retryMountTimer);
      retryMountTimer = null;
    }
    while (hubRetryTimeouts.length) {
      window.clearTimeout(hubRetryTimeouts.pop());
    }
    if (classObserver) {
      classObserver.disconnect();
      classObserver = null;
    }
  }

  window.__teaQuizStopHubClassObserver = stopHubClassObserver;

  function scheduleHubRetry(delay, fn) {
    hubRetryTimeouts.push(
      window.setTimeout(function () {
        if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) {
          stopHubClassObserver();
          return;
        }
        fn();
      }, delay)
    );
  }

  function retryMountHubPageDebounced() {
    if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) {
      stopHubClassObserver();
      return;
    }
    window.clearTimeout(retryMountTimer);
    retryMountTimer = window.setTimeout(retryMountHubPage, 150);
  }

  if (window.MutationObserver) {
    classObserver = new MutationObserver(function () {
      if (!document.documentElement.classList.contains('quiz-results-from-quiz')) return;
      var root = findHubRoot();
      if (root && root.querySelector('.quiz-constitution-results__toc-wrap')) {
        stopHubClassObserver();
        return;
      }
      if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) {
        stopHubClassObserver();
        return;
      }
      retryMountHubPageDebounced();
    });
    classObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('popstate', retryMountHubPageDebounced);

  window.addEventListener('pageshow', function (event) {
    if (window.__teaQuizIsHubStable && window.__teaQuizIsHubStable()) return;
    if (
      event.persisted ||
      shouldRenderHubNow() ||
      document.documentElement.classList.contains('quiz-results-from-quiz') ||
      (readPersistedResults() && isHubResultsUrlNow())
    ) {
      retryMountHubPageDebounced();
    }
  });
})();
